/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useState } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { AccordionCard, type AccordionCardItem } from '../accordion-card';

type AccordionCardsProps = {
	items: AccordionCardItem[];
	initialExpandedId?: string;
	testId?: string;
};

const styles = cssMap({
	cardsContainer: {
		display: 'flex',
		flexDirection: 'column',
		borderRadius: token('radius.xlarge'),
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
});

export const AccordionCardList = ({
	items,
	initialExpandedId,
	testId = 'accordion-cards',
}: AccordionCardsProps): JSX.Element => {
	const [expandedCardId, setExpandedCardId] = useState<string | null>(initialExpandedId ?? null);

	const handleCardClick = useCallback(
		(cardId: string) => {
			const newExpandedId = expandedCardId === cardId ? null : cardId;
			setExpandedCardId(newExpandedId);
		},
		[expandedCardId],
	);

	return (
		<Box xcss={styles.cardsContainer} testId={testId}>
			{items.map((item, index) => (
				<AccordionCard
					key={item.id}
					item={item}
					isExpanded={item.id === expandedCardId}
					onToggle={handleCardClick}
					isFirst={index === 0}
				/>
			))}
		</Box>
	);
};
